/**
 * Upload Service
 * Handles match upload API calls
 */

import { api } from '../utils/apiClient'
import { API_CONFIG } from '../config/constants'

/**
 * Submits match upload form
 */
export const submitMatchUpload = async (formData) => {
  try {
    // Extract only the fields needed for submission (exclude payment fields for now)
    const submissionData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      driveLink: formData.driveLink,
      matchType: formData.matchType,
      focus: formData.focus,
      videoHours: formData.videoHours,
      planId: formData.planId,
      additionalNotes: formData.additionalNotes,
    }
    
    const response = await api.post(API_CONFIG.ENDPOINTS.UPLOAD, submissionData)
    return {
      success: true,
      data: response,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to submit match',
    }
  }
}

/**
 * Tests email configuration
 */
export const testEmail = async (testEmail) => {
  try {
    const response = await api.post(API_CONFIG.ENDPOINTS.TEST_EMAIL, { testEmail })
    return {
      success: true,
      data: response,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Failed to send test email',
    }
  }
}

/**
 * Health check
 */
export const healthCheck = async () => {
  try {
    const response = await api.get(API_CONFIG.ENDPOINTS.HEALTH)
    return {
      success: true,
      data: response,
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || 'Health check failed',
    }
  }
}
